
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D80027","d":"M0 85.331h512v341.337H0z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M443.726 85.331L102.4 426.657H0V85.331z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M500.124 85.331L158.798 426.657H11.876L353.202 85.331z"}})])
          )
        }
      }
    